

































import { Site } from "@/shared/Site";
import $store from "@/store/store";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import SelectedSites from "@/ui-component/selectedSites.vue";

@Component({
  components: { SelectedSites },
})
export default class VendeurChooser extends mixins(MobileMixin) {
  public searchTxt: string = "";
  @Prop() public vendeurs!: string[];
  public selectedVendeur: string = "";

  /*
   * methode de filtre depuis le champs de texte des sites repondant au critere de texte
   */
  public searchVendeurFilter() {
    let vendeurs = this.mesVendeurs;
    if (this.searchTxt.trim() !== "") {
      vendeurs = vendeurs.filter((vendeur: string) => {
        return vendeur.includes(this.searchTxt);
      });
    }
    return vendeurs;
  }

  /*
   * methode de selection d'un vendeur
   * @param {Site} site- le site à selectionner
   */
  public selectMe(vendeur: string) {
    if (this.selectedVendeur === vendeur) {
      this.selectedVendeur = "";
      this.$emit("selectVendeur", "");
    } else {
      this.selectedVendeur = vendeur;
      this.$emit("selectVendeur", vendeur);
    }
  }

  get mesVendeurs(): string[] {
    const vendeurs = this.vendeurs.sort((u1: string, u2: string) => {
      if (u1 > u2) {
        return 1;
      }
      if (u1 < u2) {
        return -1;
      }
      return 0;
    });
    return vendeurs;
  }

  set mesVendeurs(vendeurs: string[]) {
    this.mesVendeurs = vendeurs;
  }
}
